import { render, staticRenderFns } from "./HelpSales.vue?vue&type=template&id=c66e5108&scoped=true"
import script from "./HelpSales.vue?vue&type=script&lang=js"
export * from "./HelpSales.vue?vue&type=script&lang=js"
import style0 from "./HelpSales.vue?vue&type=style&index=0&id=c66e5108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66e5108",
  null
  
)

export default component.exports